import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import Paper from "@mui/material/Paper";
import Zoom from "react-medium-image-zoom";
import { FaArrowLeft } from "react-icons/fa";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./PatientDetails.scss";
import "react-medium-image-zoom/dist/styles.css";
import Layout from "../Layouts/layout";
import { fetchData } from "../../../services/apiService";
import {
  decryptedData,
  decryptedId,
} from "../../../services/encryptionDecription.service";
import useAlertUtils from "../../../utils/common.utils";
import { TiClipboard } from "react-icons/ti";

const PatientDetails = () => {
  const [value, setValue] = useState("1");
  // const [pageLoader, setPageLoader] = useState(true)
  const navigate = useNavigate();
  const { id } = useParams();
  const [personalInfo, setPersonalInfo] = useState();
  const [medicalHistoryData, setMedicalHistoryData] = useState();
  const [healthGoalsData, setHealthGoalsData] = useState();
  const [documentsData, setDocumentsData] = useState();
  const [testData, setTestData] = useState([]);
  const [assessments, setAssessments] = useState([]);
  const [assessmentsLoading, setAssessmentsLoading] = useState(true);
  const [openAssessmentIdx, setOpenAssessmentIdx] = useState(null);
  const { alertSuccess, alertError } = useAlertUtils();
  // const role = localStorage.getItem('uR')

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const personalInformationData = async () => {
    try {
      const infoData = await fetchData(
        "/api/intakeForms/pearsonalInformation?userId=" + id
      );
      setPersonalInfo(infoData?.data);
    } catch (error) {
      alertError("Error Fetching Infos Data");
    }
  };

  const pastMedicalHistory = async () => {
    try {
      const medicalHistoryData = await fetchData(
        "/api/intakeForms/medical/history?userId=" + id
      );
      setMedicalHistoryData(medicalHistoryData?.data);
    } catch (error) {
      alertError("Error Fetching Medical History Data");
    }
  };

  const questionaires = async () => {
    try {
      const questionaries = await fetchData(
        "/api/intakeForms/questionnaires?userId=" + id
      );
      setHealthGoalsData(questionaries?.data);
    } catch (error) {
      alertError("Error Fetching Questionnaires");
    }
  };

  const documentsFunc = async () => {
    try {
      const documents = await fetchData(
        "/api/intakeForms/documents?userId=" + id
      );
      setDocumentsData(documents?.data);
    } catch (error) {
      alertError("Error Fetching Documents");
    }
  };

  const getUsersTestData = async (id) => {
    try {
      const data = await fetchData(`api/test/get-users-labTests/${id}`);
      if (data.success === true) {
        const sortedData = data.data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setTestData(sortedData);
      } else {
        alertError("Error Fetching User Data");
      }
    } catch (error) {
      alertError("Error -> ", error);
    }
  };

  const getUserAssessments = async (userIdDec) => {
    try {
      setAssessmentsLoading(true);
      const res = await fetchData(
        `/api/assessments/get-all-assessments/${userIdDec}`
      );
      if (res && (res.success === true || res.status === true)) {
        setAssessments(Array.isArray(res.data) ? res.data : []);
      } else if (Array.isArray(res)) {
        setAssessments(res);
      } else {
        setAssessments([]);
      }
    } catch (e) {
      setAssessments([]);
    } finally {
      setAssessmentsLoading(false);
    }
  };

  useEffect(() => {
    personalInformationData();
    pastMedicalHistory();
    questionaires();
    documentsFunc();
    if (id) {
      try {
        const cleanedId = decodeURIComponent(id.trim());
        const decrypted = decryptedId(cleanedId);
        getUsersTestData(decrypted);
        getUserAssessments(decrypted);
      } catch (err) {
        console.log("Error", err);
      }
    }
  }, [id]);

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div>
      <Layout>
        <div className="main_content patient_details">
          <div className="container">
            <div className="back_link">
              <Link className="action_link" onClick={handleGoBack}>
                <FaArrowLeft />
                Back
              </Link>
            </div>

            {/* Displaying Personal Info, History, Questions, and Documents tabs */}
            <div className="main_block">
              <div className="main_title">Patient Name</div>
              <div className="sub_title uppercase">
                {decryptedData(personalInfo?.firstName)}{" "}
                {decryptedData(personalInfo?.lastName)}
              </div>

              <div className="tabs">
                <TabContext value={value}>
                  <Box>
                    <TabList
                      onChange={handleChange}
                      aria-label="patient tabs example"
                    >
                      <Tab label="Personal Info" value="1" />
                      <Tab label="History" value="2" />
                      <Tab label="Questions" value="3" />
                      <Tab label="Documents" value="4" />
                      <Tab label="Lab Tests" value="5" />
                      <Tab label="Symptoms Tracker" value="6" />
                    </TabList>
                  </Box>

                  {/* Personal Info Tab Panel */}
                  <TabPanel value="1">
                    <div className="tabpanel_inner personal_info">
                      <div className="tab_data">
                        <ul className="item_wrapper">
                          <li className="item">
                            <label>Legal First Name</label>
                            <div className="value">
                              {decryptedData(personalInfo?.firstName)}
                            </div>
                          </li>
                          <li className="item">
                            <label>Legal Last Name</label>
                            <div className="value">
                              {decryptedData(personalInfo?.lastName)}
                            </div>
                          </li>
                          <li className="item">
                            <label>Gender</label>
                            <div className="value">
                              {decryptedData(personalInfo?.gender)}
                            </div>
                          </li>
                          <li className="item">
                            <label>Date of Birth</label>
                            <div className="value">
                              {decryptedData(personalInfo?.dob)}
                            </div>
                          </li>
                          <li className="item">
                            <label>Weight</label>
                            <div className="value">
                              {decryptedData(personalInfo?.weight)}
                            </div>
                          </li>
                          <li className="item">
                            <label>Height</label>
                            <div className="value">
                              {decryptedData(personalInfo?.height)} Ft{" "}
                              {decryptedData(personalInfo?.heightInInch)} Inches
                            </div>
                          </li>
                          <li className="item">
                            <label>Email ID</label>
                            <div className="value">
                              {decryptedData(personalInfo?.email)}
                            </div>
                          </li>
                          <li className="item">
                            <label>Address 1</label>
                            <div className="value">
                              {decryptedData(personalInfo?.address1)}
                            </div>
                          </li>
                          <li className="item">
                            <label>Address 2</label>
                            <div className="value">
                              {decryptedData(personalInfo?.address2)}
                            </div>
                          </li>
                          <li className="item">
                            <label>Country</label>
                            <div className="value">
                              {decryptedData(personalInfo?.country)}
                            </div>
                          </li>
                          <li className="item">
                            <label>City</label>
                            <div className="value">
                              {decryptedData(personalInfo?.city)}
                            </div>
                          </li>
                          <li className="item">
                            <label>State</label>
                            <div className="value">
                              {decryptedData(personalInfo?.state)}
                            </div>
                          </li>
                          <li className="item">
                            <label>Zip Code</label>
                            <div className="value">
                              {decryptedData(personalInfo?.zipCode)}
                            </div>
                          </li>
                          <li className="item">
                            <label>Mobile Phone</label>
                            <div className="value">
                              {decryptedData(personalInfo?.mobileNumber)}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </TabPanel>

                  {/* History Tab Panel */}
                  <TabPanel value="2">
                    <div className="tabpanel_inner history">
                      <div className="tab_data">
                        <ul className="item_wrapper">
                          <li className="item">
                            <label>Past Medical History</label>
                            <div className="value">
                              {decryptedData(
                                medicalHistoryData?.pastMedicalHistory
                              )}
                            </div>
                          </li>
                          <li className="item">
                            <label>Past Surgical History</label>
                            <div className="value">
                              {decryptedData(
                                medicalHistoryData?.pastSurgicalHistory
                              )}
                            </div>
                          </li>
                          <li className="item">
                            <label>Current Medications</label>
                            <div className="value">
                              {decryptedData(
                                medicalHistoryData?.currentMedications
                              )}
                            </div>
                          </li>
                          <li className="item">
                            <label>Current Supplements</label>
                            <div className="value">
                              {decryptedData(
                                medicalHistoryData?.currentSupplements
                              )}
                            </div>
                          </li>
                          <li className="item">
                            <label>Allergies</label>
                            <div className="value">
                              {decryptedData(medicalHistoryData?.allergies)}
                            </div>
                          </li>
                        </ul>
                        <h3 className="tab_title">Health Screenings</h3>
                        <ul className="item_wrapper">
                          <li className="item">
                            <label>Colonoscopy</label>
                            <div className="value">
                              {decryptedData(medicalHistoryData?.colonoscopy)}
                            </div>
                          </li>
                          <li className="item">
                            <label>Prostate Exam</label>
                            <div className="value">
                              {decryptedData(medicalHistoryData?.prostateExam)}
                            </div>
                          </li>
                          <li className="item">
                            <label>Mammogram</label>
                            <div className="value">
                              {decryptedData(medicalHistoryData?.mammogram)}
                            </div>
                          </li>
                          <li className="item">
                            <label>Pap Smear</label>
                            <div className="value">
                              {decryptedData(medicalHistoryData?.papSmear)}
                            </div>
                          </li>
                        </ul>
                        <h3 className="tab_title">Physician Question</h3>
                        <ul className="item_wrapper">
                          <li className="item">
                            <label>Primary Care Physician</label>
                            <div className="value">
                              {decryptedData(
                                medicalHistoryData?.currentPrimaryCarePhys
                              )}
                            </div>
                          </li>
                          <li className="item">
                            <label>Physician Telephone</label>
                            <div className="value">
                              {decryptedData(medicalHistoryData?.physTelephone)}
                            </div>
                          </li>
                          <li className="item">
                            <label>
                              Have you had a phy sical in the last year?
                            </label>
                            <div className="value">
                              {decryptedData(medicalHistoryData?.physLastYear)}
                            </div>
                          </li>
                        </ul>
                        <h3 className="tab_title">Family History</h3>
                        <ul className="item_wrapper">
                          <li className="item">
                            <label>Cardiovascular Disease</label>
                            <div className="value">
                              {decryptedData(medicalHistoryData?.haStHbPEtc)}
                            </div>
                          </li>
                          <li className="item">
                            <label>
                              Diabetes, Thyroid or Other Endocrine Disorder
                            </label>
                            <div className="value">
                              {decryptedData(medicalHistoryData?.diaThEnDis)}
                            </div>
                          </li>
                          <li className="item">
                            <label>Cancer</label>
                            <div className="value">
                              {decryptedData(medicalHistoryData?.cancer)}
                            </div>
                          </li>
                          <li className="item">
                            <label>Other Illnesses</label>
                            <div className="value">
                              {decryptedData(
                                medicalHistoryData?.otherIllnesses
                              )}
                            </div>
                          </li>
                        </ul>
                        <h3 className="tab_title">Lifestyle Information</h3>
                        <ul className="item_wrapper">
                          <li className="item">
                            <label>Used Tobacco Products</label>
                            <div className="value">
                              {decryptedData(medicalHistoryData?.tobacco)}
                            </div>
                          </li>
                          <li className="item">
                            <label>Drink Alcohol</label>
                            <div className="value">
                              {decryptedData(medicalHistoryData?.drink)}
                            </div>
                          </li>
                          <li className="item">
                            <label>Use Recreational Drugs</label>
                            <div className="value">
                              {decryptedData(medicalHistoryData?.recreDrugs)}
                            </div>
                          </li>
                          <li className="item">
                            <label>Exercise Regularly</label>
                            <div className="value">
                              {decryptedData(medicalHistoryData?.excercise)}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </TabPanel>

                  {/* Questions Tab Panel */}
                  <TabPanel value="3">
                    <div className="tabpanel_inner questions">
                      <div className="tab_data">
                        <ul className="item_wrapper">
                          <li className="item">
                            <label>Health Goals</label>
                            <div className="value">
                              {" "}
                              {healthGoalsData?.weightLoss === 1 &&
                                "Weight Loss, "}
                              {healthGoalsData?.sleep === 1 && "Sleep, "}
                              {healthGoalsData?.energy === 1 && "Energy, "}
                              {healthGoalsData?.bodyComposition === 1 &&
                                "Body Composition, "}
                              {healthGoalsData?.stress === 1 && "Stress, "}
                              {healthGoalsData?.muscleMass === 1 &&
                                "Muscle Mass, "}
                              {healthGoalsData?.libido === 1 &&
                                "Libido (Sex Drive), "}
                              {healthGoalsData?.mentalAcuity === 1 &&
                                "Mental Acuity (Focus), "}
                              {healthGoalsData?.memory === 1 && "Memory, "}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </TabPanel>

                  {/* Documents Tab Panel */}
                  <TabPanel value="4">
                    <div className="tabpanel_inner documents">
                      <div className="tab_data">
                        <div className="doc_item_wrapper">
                          <div className="doc_item">
                            <div className="doc_item_inner">
                              <h6 className="doc_title">Document 1</h6>
                              <Zoom>
                                <img
                                  src={documentsData?.document_first}
                                  alt="Document"
                                  height={150}
                                  width={200}
                                  className="document_image"
                                />
                              </Zoom>
                            </div>
                          </div>

                          <div className="doc_item">
                            <div className="doc_item_inner">
                              <h6 className="doc_title">Document 2</h6>
                              <Zoom>
                                <img
                                  src={documentsData?.document_second}
                                  alt="Document"
                                  height={150}
                                  width={200}
                                  className="document_image"
                                />
                              </Zoom>
                            </div>
                          </div>

                          <div className="doc_item">
                            <div className="doc_item_inner">
                              <h6 className="doc_title">Selfie</h6>
                              <Zoom>
                                <img
                                  src={documentsData?.selefie}
                                  alt="Document"
                                  height={150}
                                  width={200}
                                  className="document_image"
                                />
                              </Zoom>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel value="5">
                    <div className="table_wrapper dashboard">
                      <div className="table_inner">
                        <TableContainer component={Paper}>
                          <Table
                            sx={{ minWidth: 650 }}
                            aria-label="simple table"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell align="right">Test Name</TableCell>
                                <TableCell align="right">
                                  Laboratory Name
                                </TableCell>
                                <TableCell align="right">
                                  Laboratory Location
                                </TableCell>
                                <TableCell align="right">Added Date</TableCell>
                                <TableCell align="right">Action</TableCell>
                              </TableRow>
                            </TableHead>
                            {testData && testData.length !== 0 ? (
                              <TableBody>
                                {testData &&
                                  testData.map((row) => (
                                    <TableRow
                                      key={row?.id}
                                      sx={{
                                        "&:last-child td, &:last-child th": {
                                          border: 0,
                                        },
                                      }}
                                    >
                                      <TableCell align="right">
                                        <span className="mob_head">
                                          Test Name
                                        </span>
                                        {row?.testName}
                                      </TableCell>
                                      <TableCell align="right">
                                        <span className="mob_head">
                                          Laboratory Name
                                        </span>
                                        {row?.laboratoryName}
                                      </TableCell>

                                      <TableCell align="right">
                                        <span className="mob_head">
                                          Laboratory Location
                                        </span>
                                        {row?.laboratoryLocation}
                                      </TableCell>

                                      <TableCell align="right">
                                        <span className="mob_head">
                                          Added Date
                                        </span>
                                        {new Date(
                                          row?.createdAt
                                        ).toLocaleDateString("en-US", {
                                          weekday: "long",
                                          month: "long",
                                          day: "numeric",
                                        })}
                                      </TableCell>
                                      <TableCell align="right">
                                        <span className="mob_head">Action</span>
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "10px",
                                          }}
                                        >
                                          <TiClipboard
                                            onClick={() => {
                                              navigate(
                                                `/app/patient-test-details/${row?.id}`
                                              );
                                            }}
                                            size={30}
                                            color="black"
                                            cursor="pointer"
                                          />
                                        </div>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                              </TableBody>
                            ) : (
                              <TableBody>
                                <TableRow>
                                  <TableCell
                                    style={{
                                      textAlign: "center",
                                      color: "red",
                                      fontSize: "25px",
                                      padding: "30px",
                                    }}
                                    colSpan={5}
                                  >
                                    No data found
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            )}
                          </Table>
                        </TableContainer>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel value="6">
                    <div className="tabpanel_inner symptoms_tracker">
                      <div className="tab_data">
                        <div className="symptoms_tracker_data">
                          {assessmentsLoading ? (
                            <div
                              style={{
                                textAlign: "center",
                                padding: "40px 24px",
                              }}
                            >
                              Loading assessments...
                            </div>
                          ) : assessments.length === 0 ? (
                            <div
                              style={{
                                textAlign: "center",
                                padding: "40px 24px",
                                color: "#6b7280",
                              }}
                            >
                              No assessments found
                            </div>
                          ) : (
                            <div style={{ display: "grid", gap: "12px" }}>
                              {assessments.map((row, idx) => {
                                const entryDate =
                                  row.entryDate ||
                                  row.date ||
                                  row.createdAt ||
                                  row.created_at;
                                const ratingLabel =
                                  row.ratingLabel ||
                                  row.rating ||
                                  row.rating_label;
                                const totalScore =
                                  row.totalScore ??
                                  row.total ??
                                  row.total_score;
                                const maxTotal =
                                  row.maxTotal ?? row.max_total ?? row.max;

                                const safeParse = (val) => {
                                  try {
                                    let out = val;
                                    while (typeof out === "string")
                                      out = JSON.parse(out);
                                    return out;
                                  } catch {
                                    return {};
                                  }
                                };
                                const domainScores = safeParse(
                                  row.domainScores || row.domain_scores
                                );
                                const answers = safeParse(
                                  row.answers ||
                                    row.answers_json ||
                                    row.answersJson
                                );

                                const isOpen = openAssessmentIdx === idx;

                                return (
                                  <div
                                    key={row.id || idx}
                                    style={{
                                      border: "1px solid #e5e7eb",
                                      borderRadius: "12px",
                                      overflow: "hidden",
                                      background: "#fff",
                                    }}
                                  >
                                    <button
                                      onClick={() =>
                                        setOpenAssessmentIdx(
                                          isOpen ? null : idx
                                        )
                                      }
                                      style={{
                                        width: "100%",
                                        textAlign: "left",
                                        padding: "12px 14px",
                                        background: "#f9fafb",
                                        border: "none",
                                        borderBottom: "1px solid #e5e7eb",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "baseline",
                                          gap: "12px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            fontWeight: 700,
                                            color: "#111827",
                                          }}
                                        >
                                          {new Date(
                                            entryDate
                                          ).toLocaleDateString()}
                                        </div>
                                        <div
                                          style={{
                                            color: "#374151",
                                            fontWeight: 700,
                                          }}
                                        >
                                          {totalScore}{" "}
                                          <span style={{ color: "#9ca3af" }}>
                                            / {maxTotal}
                                          </span>
                                        </div>
                                      </div>
                                      <div
                                        style={{
                                          fontWeight: 700,
                                          color: "#9f1239",
                                        }}
                                      >
                                        {ratingLabel}
                                      </div>
                                    </button>

                                    {isOpen && (
                                      <div style={{ padding: "12px 14px" }}>
                                        {domainScores &&
                                          Object.keys(domainScores).length >
                                            0 && (
                                            <div
                                              style={{ marginBottom: "12px" }}
                                            >
                                              <div
                                                style={{
                                                  fontWeight: 700,
                                                  color: "#111827",
                                                  marginBottom: "8px",
                                                }}
                                              >
                                                Domain Scores
                                              </div>
                                              <div
                                                style={{
                                                  display: "grid",
                                                  gap: "10px",
                                                }}
                                              >
                                                {Object.entries(
                                                  domainScores
                                                ).map(([label, obj]) => {
                                                  const value =
                                                    (obj && obj.value) ?? 0;
                                                  const max =
                                                    (obj && obj.max) ?? 1;
                                                  const pct = Math.min(
                                                    100,
                                                    Math.max(
                                                      0,
                                                      Math.round(
                                                        (value / max) * 100
                                                      )
                                                    )
                                                  );
                                                  return (
                                                    <div key={label}>
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          justifyContent:
                                                            "space-between",
                                                          fontSize: 13,
                                                          color: "#374151",
                                                          marginBottom: 4,
                                                        }}
                                                      >
                                                        <span>{label}</span>
                                                        <span
                                                          style={{
                                                            color: "#6b7280",
                                                          }}
                                                        >
                                                          {value}/{max}
                                                        </span>
                                                      </div>
                                                      <div
                                                        style={{
                                                          height: 8,
                                                          background: "#f3f4f6",
                                                          borderRadius: 999,
                                                          overflow: "hidden",
                                                        }}
                                                      >
                                                        <div
                                                          style={{
                                                            height: "100%",
                                                            width: pct + "%",
                                                            background:
                                                              "linear-gradient(90deg,#e11d48,#ec4899)",
                                                          }}
                                                        />
                                                      </div>
                                                    </div>
                                                  );
                                                })}
                                              </div>
                                            </div>
                                          )}

                                        {answers &&
                                          Object.keys(answers).length > 0 && (
                                            <div>
                                              <div
                                                style={{
                                                  fontWeight: 700,
                                                  color: "#111827",
                                                  marginBottom: "8px",
                                                }}
                                              >
                                                Answers
                                              </div>
                                              <div
                                                style={{
                                                  display: "grid",
                                                  gap: 12,
                                                  gridTemplateColumns: "1fr",
                                                }}
                                              >
                                                {Object.entries(answers).map(
                                                  ([k, v]) => (
                                                    <div
                                                      key={k}
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "space-between",
                                                        border:
                                                          "1px solid #e5e7eb",
                                                        borderRadius: 12,
                                                        padding: "8px 12px",
                                                        background: "#fff",
                                                      }}
                                                    >
                                                      <div
                                                        style={{
                                                          color: "#374151",
                                                          fontWeight: 600,
                                                          fontSize: 13,
                                                        }}
                                                      >
                                                        {k
                                                          .charAt(0)
                                                          .toUpperCase() +
                                                          k.slice(1)}
                                                      </div>
                                                      <div
                                                        style={{
                                                          background: "#fee2e2",
                                                          color: "#991b1b",
                                                          border:
                                                            "1px solid #fecaca",
                                                          padding: "4px 10px",
                                                          borderRadius: 999,
                                                          fontWeight: 700,
                                                          fontSize: 12,
                                                        }}
                                                      >
                                                        {String(v)}
                                                      </div>
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                            </div>
                                          )}
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </TabContext>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default PatientDetails;
